module.exports = __webpack_public_path__ + "static/media/SWSCRC1-27.28b643b1.mp3";